import { RadioGroup as RadioGroupBase } from 'common-components'

const RadioGroupComponent = ({ options, onClick, value, disabled }) => (
  <RadioGroupBase options={options} value={value} setValue={onClick} disabled={disabled} />
)

const HookComponent = (hoc) => {
  const WrappedRadioGroup = hoc ? hoc(RadioGroupComponent) : RadioGroupComponent

  return function(props) {
    const { setValue, customOnClick, value } = props

    const onClick = (option) => {
      if (!!customOnClick) customOnClick(option)
      setValue(option)
    }
    const valueRadio = _.get(value, 'value')

    return <WrappedRadioGroup {...props} onClick={onClick} value={valueRadio} />
  }
}

export default HookComponent
